//（PC/Mobile）
export const isMobile = () => {
  return true;
  const ua = navigator.userAgent;
  return /(phone|iPhone|Android|Mobile)/i.test(ua);
};

export const loadDeviceStyle = () => {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = isMobile()
    ? require('@/styles/mobile.less')
    : require('@/styles/pc.less');
  document.head.appendChild(link);
};
